import {
  StyledTableCell,
  StyledTableCellName,
  StyledTableRow,
} from 'components/styles_components/table';

const ShowItemTableRow = ({ label, children, emptyComponent = '-' }) => {
  return (
    <StyledTableRow>
      <StyledTableCellName>{label}</StyledTableCellName>
      <StyledTableCell align="right">
        {children != null && children !== '' ? children : emptyComponent}
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default ShowItemTableRow;
